(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["company-spotlight"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    const trigger = event.target.closest('[data-v3-video-trigger]');
    if (!trigger) return;
    const wrapper = trigger.closest('[data-v3-video]');
    const template = wrapper.querySelector('[data-v3-video-template]');
    const player = wrapper.querySelector('[data-v3-player]');
    if (!template || !player) return;
    const iframe = template.content.querySelector('iframe').cloneNode(true);
    iframe.src = iframe.dataset.src;
    iframe.removeAttribute('data-src');
    player.replaceChildren(iframe);
    player.hidden = false;
    trigger.hidden = true;
    iframe.focus();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
document.addEventListener('change', function(event) {
  const select = event.target.closest('[data-products-per-page]');
  if (!select) return;
  const url = new URL(window.location.href);
  if (select.value === '25') {
    url.searchParams.delete('view');
  } else {
    url.searchParams.set('view', select.value);
  }
  url.searchParams.delete('page');
  window.location.assign(url.toString());
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  function showImage(root, id) {
    const gallery = root.querySelector('[data-v3-gallery]');
    if (!gallery || !gallery.querySelector(`[id="${CSS.escape(id)}"]`)) return;
    gallery.querySelectorAll('[data-v3-product-image]').forEach(image => { image.hidden = image.id !== id; });
    gallery.querySelectorAll('[data-v3-image-target]').forEach(button => { button.setAttribute('aria-pressed', String(button.dataset.v3ImageTarget === id)); });
  }
  function initialize(scope) {
    scope.querySelectorAll('[data-v3-gallery]').forEach(gallery => {
      const thumbnails = gallery.querySelector('[data-v3-thumbnails]');
      if (!thumbnails || gallery.classList.contains('is-enhanced')) return;
      gallery.classList.add('is-enhanced');
      thumbnails.hidden = false;
      const root = gallery.closest('[data-v3-product-root]');
      const initialId = gallery.dataset.v3InitialImage;
      const first = gallery.querySelector(`[data-v3-image-id="${CSS.escape(initialId || '')}"]`) || gallery.querySelector('[data-v3-product-image]');
      if (root && first) showImage(root, first.id);
    });
  }
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-v3-image-target]');
    const root = button?.closest('[data-v3-product-root]');
    if (button && root) showImage(root, button.dataset.v3ImageTarget);
  });
  document.addEventListener('change', event => {
    if (!(event.target instanceof Element)) return;
    const select = event.target.closest('[data-v3-variant-select]');
    const root = select?.closest('[data-v3-product-root]');
    const option = select?.selectedOptions[0];
    if (!root || !option) return;
    const available = option.dataset.available === 'true';
    const price = root.querySelector('[data-v3-price]');
    const availability = root.querySelector('[data-v3-availability]');
    const button = root.querySelector('[data-v3-add-button]');
    const quantity = root.querySelector('[data-v3-quantity]');
    const sku = root.querySelector('[data-v3-sku]');
    const skuWrap = root.querySelector('[data-v3-sku-wrap]');
    if (price) price.textContent = option.dataset.price;
    if (availability) availability.textContent = available ? root.dataset.availableLabel : root.dataset.soldLabel;
    if (button) { button.disabled = !available; button.textContent = available ? button.dataset.addLabel : root.dataset.soldLabel; }
    if (quantity) { quantity.min = option.dataset.min || '1'; quantity.step = option.dataset.step || '1'; if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max'); quantity.value = quantity.min; }
    if (sku) sku.textContent = option.dataset.sku || '';
    if (skuWrap) skuWrap.hidden = !option.dataset.sku;
    if (option.dataset.image) { const image = root.querySelector(`[data-v3-image-id="${CSS.escape(option.dataset.image)}"]`); if (image) showImage(root, image.id); }
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    history.replaceState({}, '', url);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["site-header"]) return;
  try {
    
  document.addEventListener('click', function (event) {
    const closeButton = event.target.closest('[data-v3-close-menu]');
    if (!closeButton) return;
    const menu = closeButton.closest('[data-v3-mobile-menu]');
    if (!menu) return;
    menu.open = false;
    menu.querySelector('summary').focus();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const menu = document.querySelector('[data-v3-mobile-menu][open]');
    if (!menu || menu.offsetParent === null) return;
    menu.open = false;
    menu.querySelector('summary').focus();
  });
  document.addEventListener('click', function (event) {
    const link = event.target.closest('[data-v3-mobile-menu] a');
    if (!link) return;
    const destination = new URL(link.href, window.location.href);
    if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname || !destination.hash) return;
    const target = document.getElementById(decodeURIComponent(destination.hash.slice(1)));
    if (!target) return;
    link.closest('[data-v3-mobile-menu]').open = false;
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
  });

  } catch(e) { console.error(e); }
})();
})();
